import jsMd5 from 'js-md5';
// 加密-服务
export default {
  /**
   * md5
   *
   * @params value 加密的字符串
   */
  md5(value = '') {
    if (value) return jsMd5(value);
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/encrypt.js